export class ApplicationSearchConstants {
    static COMPONENT_NAME = "ApplicationSearch";
    static FILTER_NAME_TEXT = "What to search";
    static FILTER_TYPE_TEXT = "Type";
    static FILTER_OPERATOR_TEXT = "Condition";
    static VALUE_OPERATOR_TEXT = "Value to search";
    static PARENT_COMPONENT_NAME = "ApplicationSearchComponent";
    static PAGE_HEADING = "Search";
    static SEARCH_OPTION_CONTROL = "searchOptionFormControl";
    static SELECT_OPTION_CONTROL = "selectOptionFormControl";
    static SEARCH_OPTION_CONTROL_LABEL = "From:";
    static SELECT_OPTION_CONTROL_LABEL = "Select:";
    static QUERY_BUILDER_HEADING_LABEL = "Search query builder";
    static SEARCH_RESULTS_HEADING_LABEL = "Search results";
    static SELECT_ALL_LABEL = "Select all";
    static SHOW_HIDE_COLUMNS_LABEL = "Show/hide display columns";
    static SHOW_HIDE_FILTERS_LABEL = "Show/hide filters";
    static RESET_LABEL = "Reset";
    static SEARCH_LABEL = "Search";
    static ADD_ITEM_LABEL = "Add item";
    static LOOKUP_VALUE_PLACEHOLDER = "Select lookup value";
    static LOOKUP_SIMPLE_PLACEHOLDER = "Select value";
    static USER_SEARCH_PLACEHOLDER = "Select or search users";
    static OPERATORS = ["=", "!=", "like", "not like", "<", "<=", ">", ">="];
    static DESCRIPTION_LABEL1 = "Select a pre-configured search, choose which columns to display, then complete the filters below. Empty filters are ignored.";
    static DESCRIPTION_LABEL2 = "Next select from the pre-configured columns you would like to display in your result (by default all columns are selected).";
    static DESCRIPTION_LABEL3 = "Next complete the pre-configured list of filters and click search, if no value is provided for a filter, the search will ignore the filter criteria.";
    static NO_SEARCH_SELECTED = "Please select a search option.";
    static NO_DISPLAY_FIELDS_SELECTED = "Please select at minimum one field to include in the search result.";
    static NO_SEARCHES_MESSAGE = "No searches configured, please contact your system administrator.";
    static MINIMUM_SELECTION_MESSAGE_FILTER = "Please filter by at minimum one field to search.";
    static NO_RESULTS_FOUND = "No results found matching your search criteria.";
    static SEARCH_CONFIG_INCOMPLETE_MESSAGE = "Selected search configuration incomplete, please check that the display fields and filters are configured.";
    static WHERE_TOOLTIP_TEXT = "Define the criteria to filter your application search";
    static FILTER_NAME_TOOLTIP_TEXT = "Pre-defined field names that you can filter or search by";
    static FILTER_OPERATOR_TOOLTIP_TEXT = "Select an operator type to compare the field against the value";
    static FILTER_VALUE_TOOLTIP_TEXT = "Enter the value that you want to search by";
}
